// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"789":"ca68f798854c34db","2264":"04b58996d58b2dee","6488":"3ce42c46b258faf8","8622":"6e5afecd8939239a"}[chunkId] + ".css";
};